<app-base-modal
  title="{{ (isActivation ? 'USER_ACTIVATE.CONFIRM_TITLE' : 'USER_DEACTIVATE.CONFIRM_TITLE') | translate }}"
  [showClose]="showClose"
  (closeCross)="onCancel()"
>
  <ng-container modal-body-content>
    <p>{{ (isActivation ? 'USER_ACTIVATE.CONFIRM_MESSAGE' : 'USER_DEACTIVATE.CONFIRM_MESSAGE') | translate }}</p>
  </ng-container>
  @if (showBtns) {
    <ng-container modal-footer-content>
      @if (!isLoading) {
        <div class="d-flex align-items-center w-100 justify-content-between">
          <button type="button" ngbAutofocus class="btn btn-outline-secondary" (click)="onCancel()">
            {{ 'COMMON.CANCEL' | translate }}
          </button>
          <button type="button" ngbAutofocus class="btn btn-danger" (click)="onConfirm()">
            {{ 'COMMON.CONFIRM' | translate }}
          </button>
        </div>
      } @else {
        <div class="d-flex w-100 justify-content-center">
          <div class="spinner-border" role="status"></div>
        </div>
      }
      <ng-template #spinner>
        <div class="d-flex w-100 justify-content-center">
          <div class="spinner-border" role="status"></div>
        </div>
      </ng-template>
    </ng-container>
  }
</app-base-modal>
